import React, { ForwardedRef, forwardRef } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    className?: string;
}

// eslint-disable-next-line react/display-name
const Input = forwardRef((props: InputProps, ref: ForwardedRef<HTMLInputElement>) => {
    const combinedClass = (props.className ?? '') + ' '
    // eslint-disable-next-line max-len
    + 'g-gray-50 bg-mid-blue text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-gray-300 block w-full p-1 bg- border-gray-600 placeholder-gray-400 text-white focus:ring-gray-300 focus:border-gray-300';

    return (
        <input ref={ref} {...props} className={combinedClass} />
    );
});

export default Input;
